module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.screenFullFlag),
      expression: "screenFullFlag",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "app",
    class: {
      back: _vm.back_flag
    },
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-46cbabed!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 736
// module chunks = 1